import { isImmutable, Map, Record } from "immutable";
import { isNil } from "lodash";

import dateWithTimestamp from "../modules/definition/calendar/dateFunctions/dateWithTimestamp";
import createFromJS from "../types/createFromJS";

/**
 * True if all date property values (era, year etc.) status match that of timestamp
 * i.e all null OR all not null
 * @param {DateRecord} date
 */
const isValidDateRecord = date => {
  const isTSNill = isNil(date.timestamp);
  return (
    date.toSeq().find((value, prop) => {
      return prop !== "precision" && prop !== "timestamp" && isNil(value) !== isTSNill;
    }) === undefined
  );
};

/**
 * This function fix that the values like Era, Year, Month are calculated properly
 * according to the timestamp.
 * @param {DateRecord} dateRecord
 * @param {CalendarRecord} calendar
 */
const fixDateRecord = (dateRecord, calendar) =>
  isValidDateRecord(dateRecord) ? dateRecord : dateWithTimestamp(calendar, dateRecord.timestamp, dateRecord.precision);

const fixingRecords = Map({
  DateRecord: fixDateRecord
});

/**
 * Fix all the types of Records in the fixingRecords for the target record instance
 * Because the Record does not have iterator functions,
 * it has to be converted to Immutable Sequence to traverse the properties.
 * Therefore, this function needs an Record name to
 * convert the result back to the original Record type
 * @param {Record} record
 * @param {string} recordName
 * @param {CalendarRecord} calendar
 * @returns {object | Record}
 */
const repairRecordTree = (record, recordName, calendar) => {
  const fixed = record
    .toSeq()
    .map(propValue => {
      let result = propValue;
      if (Record.isRecord(propValue) || isImmutable(propValue)) {
        const name = Record.getDescriptiveName(propValue);
        const fixFunc = fixingRecords.get(name);
        result = fixFunc ? fixFunc(propValue, calendar) : repairRecordTree(propValue, "", calendar);
      }
      return result;
    })
    .toJS();
  return recordName && createFromJS[recordName] ? createFromJS[recordName](fixed) : fixed;
};

export default repairRecordTree;
